export function Database() {
  const url = "https://b2bfull-backend-v1.onrender.com";
  return url;
}
